export const ALHUBU_BUSINESS_ID = "1889979516399390720";

export const isAlhubuBusiness = (businessID) => String(businessID) === ALHUBU_BUSINESS_ID;

export const ARGYMAQ_BRANCH_IDS = ["1990319019407708160", "1990320835134492672", "2034213686763065344"];

export const isArgymaqBranch = (branchID) => ARGYMAQ_BRANCH_IDS.includes(String(branchID));
